import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/bombas/BombasMultietapa/BombasMultietapa1.png';
import Img2 from '../../img/products/bombas/BombasMultietapa/BombasMultietapa2.png';
import Img3 from '../../img/products/bombas/BombasMultietapa/BombasMultietapa3.png';
import Img4 from '../../img/products/bombas/BombasMultietapa/BombasMultietapa4.png';

const BombasMultietapas = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Bombas Multietapas</h2>

      {/* Estilos inline o puedes mover esto a tu CSS */}
      <style>{`
        .img-hover-zoom {
          transition: transform 0.3s ease;
        }

        .img-hover-zoom:hover {
          transform: scale(1.05);
        }
      `}</style>

      <div className="row align-items-start mb-5">
        {/* Columna izquierda: imágenes en cuadrícula */}
        <div className="col-md-5">
          <div className="row g-2">
            <div className="col-6">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 1" />
            </div>
            <div className="col-6">
              <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 2" />
            </div>
            <div className="col-6">
              <img src={Img3} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 3" />
            </div>
            <div className="col-6">
              <img src={Img4} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 4" />
            </div>
          </div>
        </div>

        {/* Columna derecha: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            Las bombas multietapas son un tipo de bomba centrífuga que cuenta con múltiples impulsores 
            montados en serie en un mismo eje, lo que permite aumentar la presión del líquido bombeado 
            en cada etapa sucesiva. 
          </p>
          <p className="lead text-justify">
            Estas bombas son altamente eficientes y se utilizan en una amplia variedad de aplicaciones.
            Cada impulsor aumenta la presión del líquido, lo que permite alcanzar altos niveles de presión 
            y caudal. A pesar de tener múltiples etapas, estas bombas suelen tener un diseño compacto 
            y eficiente en cuanto al espacio. 
          </p>
          <p className="lead text-justify">
            Disponibles en diferentes configuraciones horizontales y verticales para adaptarse a diversas
            aplicaciones. Las bombas multietapas son conocidas por su alta eficiencia energética, lo que 
            se traduce en menores costos operativos.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BombasMultietapas;
